(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairEmailExhibitorsSelectionController', PhysicalFairEmailExhibitorsSelectionController);
    PhysicalFairEmailExhibitorsSelectionController.$inject = ['$uibModal', 'ExpoService', 'CitiesByExpoService', 'PhysicalFairService','$scope'];
    function PhysicalFairEmailExhibitorsSelectionController($uibModal, ExpoService, CitiesByExpoService, PhysicalFairService,$scope) {
        var vm = this;

        vm.flag = false;
        vm.flightsRequests = [];
        vm.expoSelected = [];
        vm.i = -1;
        vm.selectExpo = selectExpo;
        vm.getByFilter = getByFilter;
        vm.getExhibitorsFromExpoLocationId = getExhibitorsFromExpoLocationId;
        //vm.getExhibitorsFromExpoId          = getExhibitorsFromExpoId;
        vm.updateExhibitorsSelected = updateExhibitorsSelected;
        vm.getAllExhibitorsFromExpoLocationId = getAllExhibitorsFromExpoLocationId;
        vm.locations = [];
        vm.exhibitorsFlag = false;
        vm.exhibitors = [];
        vm.exhibitorsTab = false;
        vm.selectedCity = "";
        vm.exhibitorSelections = [];
        vm.exhibitorsUnregisteredFlag = false;

        /*PAGINATION*/
        vm.pageChanged = pageChanged;
        vm.setPage = setPage;
        vm.to = [];
        vm.totalItems = [];
        vm.currentPage = null;
        vm.itemsPerPage = [];
        vm.page = 1;

        function activate() {
            vm.selectExpo();
        }

        function selectExpo() {
            ExpoService.getExpos().then(function (response) {
                vm.expo = response.data;
            }).catch(function (err) {
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};
            if (typeof vm.expoSelected !== 'undefined') {
                vm.query['expo_id'] = vm.expoSelected.id;
            }
            if (vm.page !== null)
                vm.query['page'] = vm.page;

            /* Load variables to CSV */

            PhysicalFairService.getExhibitorsFromExpoId(vm.query).then(function (response) {
                vm.exhibitors = response.data;
                console.log(vm.exhibitors.unregistered);
                if (vm.exhibitors.length == 0) {
                    vm.noResultMessage = 'Sorry, no results were found!';
                    vm.flag = false;
                } else {
                    vm.noResultMessage = '';
                    vm.flag = true;
                }
                if(vm.selectedCity && vm.selectedCity.id > 0)
                {
                    getExhibitorsFromExpoLocationId(vm.selectedCity.id);
                }
            }).catch(function (err) {
            });
        }

        function getExhibitorsFromExpoLocationId(expoLocationId){
            vm.exhibitorsTab = vm.exhibitors.registered.exhibitors[expoLocationId];
            vm.selectedCity = vm.exhibitors.registered.locations[expoLocationId];
        }

        function getAllExhibitorsFromExpoLocationId(expoLocationId) {
            //vm.flag = false;
            vm.query = {};
            if (typeof vm.expoSelected !== 'undefined') {
                vm.query['expo_id'] = vm.expoSelected.id;
            }
            vm.query['expo_location_id'] = expoLocationId;

            PhysicalFairService.getAllExhibitorsFromExpoLocationId(vm.query).then(function (response) {
                vm.exhibitorsModal = response.data;
                console.log(vm.exhibitorsModal);
                vm.exhibitorSelections = vm.exhibitorsModal.selections_ids[expoLocationId];
                vm.modalInstance = $uibModal.open({
                    templateUrl: 'templates/physicalfairs/reports/email-exhibitors-selection/edit-exhibitors.html',
                    scope: $scope,
                    size: 'lg',
                    resolve: {
                        invoices : function () {
                            return vm.exhibitorsModal;
                        }
                    }
                });
            }).catch(function (err) {
            });
        };
        function updateExhibitorsSelected(expoLocationId)
        {
            vm.query = {};
            vm.query['exhibitorSelections'] = vm.exhibitorSelections;
            vm.query['expo_id']  = vm.expoSelected.id;
            if(expoLocationId > 0)
            {
                vm.query['expo_location_id']  = expoLocationId;
            }
            PhysicalFairService.updateExhibitorsSelected(vm.query).then(function(response){
                vm.selections = response.data;
                getByFilter();
                if(vm.modalInstance)
                {
                    vm.modalInstance.close();
                }
                console.log(vm.selections);
            }).catch(function(err){
            });
        }
        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }
        vm.toggleSelection = function toggleSelection(userId) {

            var idx = vm.exhibitorSelections.indexOf(userId);

            // Is currently selected
            if (idx > -1) {
                vm.exhibitorSelections.splice(idx, 1);
            }

            // Is newly selected
            else {
                vm.exhibitorSelections.push(userId);
            }

            console.log(vm.exhibitorSelections);
        };

        activate();
    }
})();